/* unplugin-vue-components disabled */import script from "./changeGame.vue?vue&type=script&setup=true&lang=ts"
export * from "./changeGame.vue?vue&type=script&setup=true&lang=ts"

import "./changeGame.vue?vue&type=style&index=0&id=352bbee2&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/.pnpm/vue-loader@16.8.3_2s7cwfl64decoaat2pz2tykl6i/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-352bbee2"]])

export default __exports__